import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getGachaToken } from '@/services/playerService';
import { useAppStore } from '@/hooks/useAppStore';
import { storeAuthToken } from '@/lib/auth';
import { LoaderCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const DEFAULT_PROVIDER = 'ggl'; //as passed by player service

/**
 * Backend redirects to this page after OAuth success with the access token as a Query/URL param. 
 * We exchange the provider's access token with an internal auth token (player-service) that 
 * wraps the provider token and creates a user in DB etc.
 */
export const AuthCallbackPage = () => {
  const setUser = useAppStore((state) => state.setUser);
  const { token: providerToken } = useParams();

  const [searchParams] = useSearchParams();
  const provider = searchParams.get('provider') || DEFAULT_PROVIDER;

  const navigate = useNavigate();

  useEffect(() => {
    if (providerToken) {
      getGachaToken(providerToken, provider).then((gachaToken: string) => {
        const user = storeAuthToken(gachaToken);
        setUser(user);
        // We should be parsing this from a callback param in the future
        const storedPath = searchParams.get("returnTo");
        if (storedPath) {
          navigate(storedPath);
        } else {
          navigate("/translate");
        }
      })
    } else {
      console.error("URL parameter token is missing, redirecting to login");
      navigate("/login");
    }
  }, [providerToken]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
      <Card className="w-full max-w-sm bg-neutral-800 border-neutral-700 text-white">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-thin uppercase tracking-[4px] text-chotto-gold">
            Chotto ゲスト
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          <div className="flex flex-col items-center justify-center">
            <div className="w-full text-center my-4" >
              <LoaderCircle className="inline-flex animate-spin w-4 h-4 mr-1" />
              Loading ...
            </div>
          </div>
        </CardContent>
      </Card>
    </div>);
};
